import * as React from "react"
import { keyframes } from "@emotion/react"
import { useTheme } from "@mui/material"

import { AdminNewListedBaseTable } from "../@components"
import { adminNewListedTableData } from "../@signals"


export default function AdminNewListedRawTable() {
	const { palette } = useTheme()

	return <AdminNewListedBaseTable
		title="Raw Products and Associated SKUs"
		subtitle="List of raw products and the SKU it has been associated with."
		data={adminNewListedTableData.value}
		options={{
			enhancedSetRowProps: () => ({ sx: {
				"&:has(.is-loading)": {
					animation: `${keyframes({
						"0%": { backgroundColor: palette.info.light },
						"100%": { backgroundColor: palette.info.lighter }
					})} 1s linear infinite alternate`
				},
				"&:has(.is-open)": {backgroundColor: "warning.light"},
				"&:has(.is-open-num-items)": { backgroundColor:  `${palette.warning.lighter} !important` }
			} })
		}}
	/>
}